"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DesktopModal = require("./DesktopModal");
Object.keys(_DesktopModal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DesktopModal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DesktopModal[key];
    }
  });
});